export type ColumnId =
  | 'artwork'
  | 'title'
  | 'artist'
  | 'release'
  | 'release_year'
  | 'create_date'
  | 'include_date'
  | 'status'
  | 'collections'
  | 'bpm'
  | 'genre'
  | 'explicitness'
  | 'rating'
  | 'vibes'
  | 'decade'
  | 'holiday'
  | 'occasion'
  | 'gain'
  | 'isrc'
  | 'duration';

export type CatalogSortColumn =
  | 'title'
  | 'artist'
  | 'release'
  | 'release_year'
  | 'create_date'
  | 'include_date'
  | 'status'
  | 'bpm'
  | 'rating'
  | 'explicitness'
  | 'gain'
  | 'isrc'
  | 'duration'
  | null;

export const VALID_SORT_COLUMNS: CatalogSortColumn[] = [
  'title',
  'artist',
  'release',
  'release_year',
  'create_date',
  'include_date',
  'status',
  'bpm',
  'rating',
  'explicitness',
  'gain',
  'isrc',
  'duration',
];

export interface ColumnConfig {
  id: ColumnId;
  label: string;
  sortable: boolean;
}

export const COLUMN_DEFINITIONS: ColumnConfig[] = [
  { id: 'artwork', label: 'Artwork', sortable: false },
  { id: 'title', label: 'Title', sortable: true },
  { id: 'artist', label: 'Artist', sortable: true },
  { id: 'release', label: 'Release', sortable: true },
  { id: 'release_year', label: 'Release Year', sortable: true },
  { id: 'create_date', label: 'Date Added', sortable: true },
  { id: 'include_date', label: 'Date Included', sortable: true },
  { id: 'status', label: 'Status', sortable: true },
  { id: 'collections', label: 'Collections', sortable: false },
  { id: 'bpm', label: 'BPM', sortable: true },
  { id: 'genre', label: 'Genre', sortable: false },
  { id: 'explicitness', label: 'Explicit', sortable: true },
  { id: 'rating', label: 'Rating', sortable: true },
  { id: 'vibes', label: 'Vibes', sortable: false },
  { id: 'decade', label: 'Decade', sortable: false },
  { id: 'holiday', label: 'Holiday', sortable: false },
  { id: 'occasion', label: 'Occasion', sortable: false },
  { id: 'gain', label: 'Gain', sortable: true },
  { id: 'isrc', label: 'ISRC', sortable: true },
  { id: 'duration', label: 'Duration', sortable: true },
];
